// frontend/src/utils/currencyMapper.js
export const getTimezoneCurrency = (timezone) => {
  const tz = timezone?.trim() || 'UTC';

  // Exact timezone matches
  const exactMap = {
    'Asia/Dhaka': { code: 'BDT', symbol: '৳' },
    'Asia/Kolkata': { code: 'INR', symbol: '₹' },
    'Asia/Kathmandu': { code: 'NPR', symbol: '₨' },
    'Asia/Tokyo': { code: 'JPY', symbol: '¥' },
    'Asia/Shanghai': { code: 'CNY', symbol: '¥' },
    'Europe/London': { code: 'GBP', symbol: '£' },
    'Europe/Paris': { code: 'EUR', symbol: '€' },
    'Europe/Berlin': { code: 'EUR', symbol: '€' },
    'Europe/Madrid': { code: 'EUR', symbol: '€' },
    'America/New_York': { code: 'USD', symbol: '$' },
    'America/Chicago': { code: 'USD', symbol: '$' },
    'America/Denver': { code: 'USD', symbol: '$' },
    'America/Los_Angeles': { code: 'USD', symbol: '$' },
    'America/Toronto': { code: 'CAD', symbol: 'CA$' },
    'Australia/Sydney': { code: 'AUD', symbol: 'A$' },
    'Africa/Cairo': { code: 'EGP', symbol: 'E£' },
    'Asia/Singapore': { code: 'SGD', symbol: 'S$' },
    'Asia/Hong_Kong': { code: 'HKD', symbol: 'HK$' },
  };

  if (exactMap[tz]) return exactMap[tz];

  // Region-based fallbacks
  if (tz.startsWith('Europe/')) return { code: 'EUR', symbol: '€' };
  if (tz.startsWith('Asia/')) return { code: 'USD', symbol: '$' }; // Fallback for unlisted Asia
  if (tz.startsWith('America/')) return { code: 'USD', symbol: '$' };
  if (tz.startsWith('Australia/')) return { code: 'AUD', symbol: 'A$' };
  if (tz.startsWith('Africa/')) return { code: 'USD', symbol: '$' };

  // Default
  return { code: 'USD', symbol: '$' };
};